import { ChangeDetectionStrategy, Component, computed, inject, isSignal, ViewEncapsulation } from '@angular/core';
import { SettingsMap } from '@partners/settings';
import { ShellStore } from '@partners/state';
import { ThemeAssetComponent } from '@partners/themes';
import { isUndefined } from '@partners/utils';

@Component({
  selector: 'secondary-logo',
  standalone: true,
  imports: [ThemeAssetComponent],
  template: `
    @if(hasSecondaryLogo()) {
    <theme-asset [loadViaHttp]="true" asset="cal-logo"></theme-asset>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'secondary-logo'
  }
})
export class SecondaryLogoComponent {
  #shellStore = inject(ShellStore);

  readonly defaultLogoName = 'cal-logo';

  hasSecondaryLogo = computed<boolean>(() => {
    if (!isSignal(this.#shellStore.params$$)) {
      return false;
    }

    if (isUndefined(this.#shellStore.params$$())) {
      return false;
    }

    const { partner } = this.#shellStore.params$$();
    const themeSettings = SettingsMap.themeSettings(partner);

    /** if no settings are found for this partner's secondary logo - we apply the default: visible */
    if (isUndefined(themeSettings?.isSecondaryLogoVisible)) {
      return true;
    }

    const { isSecondaryLogoVisible } = themeSettings;

    return isSecondaryLogoVisible;
  });
}
